import { inject, Injector } from '@angular/core';
import { signalStore, withMethods, withProps, withState } from '@ngrx/signals';
import { initialTipoContattoState } from './tipo_contatto.state';
import { getTipoContatto } from './tipo_contatto.utility';
import { GetTipoContattoGQL } from '../../_graphql/generated';

export const TipoContattoStore = signalStore(
  { providedIn: 'root' },
  withState(initialTipoContattoState),
  withProps(() => ({
    getter: inject(GetTipoContattoGQL),
  })),
  withMethods(({ getter, ...store }, injector = inject(Injector)) => ({
    init: getTipoContatto(injector, store, getter),
  }))
);
